import request from '@/utils/request'
// 获取gpt登录token
export function getAuthToken(query) {
  return request({
    url: '/openapi/token/auth',
    method: 'get',
    params: query
  })
}
